import { AfterViewInit, Component, Input, OnInit, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { GuardianState } from '../guardian/guardian.state';
import { RootState } from '../store/root.state';
import { Guardian, IApplicationContent } from '../types';
import { ContentService } from '../services/content.service';
import { SafeHtml } from '@angular/platform-browser';
import { filter, take } from 'rxjs/operators';
import { FullNamePipe } from '../pipes/full-name.pipe';
import { NgxsFormDirective } from '@ngxs/form-plugin';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';
import { IAppSettings, APP_CONFIG } from '@nha/config/interfaces/iapp-settings.interface';

declare const $: any;
@Component({
    selector: 'app-terms-conditions',
    templateUrl: './terms-conditions.component.html',
    styleUrls: ['./terms-conditions.component.scss'],
    imports: [NgIf, FormsModule, NgxsFormDirective, ReactiveFormsModule, NgFor, AsyncPipe, FullNamePipe]
})
export class TermsConditionsComponent implements OnInit, AfterViewInit {
	appSettings = inject<IAppSettings>(APP_CONFIG);
	@Input() showTermsAndConditions;

	content$: Observable<IApplicationContent>;

	termsConditionsForm: UntypedFormGroup;
	guardians: Guardian[];
	termsConditionsUrl: string;
	serviceUrl = this.appSettings.api.application;
	culture = window['nha-sa-culture'];

	termsAndConditions$: Observable<SafeHtml>;

	constructor(private fb: UntypedFormBuilder, private store: Store, private contentService: ContentService) {
		this.content$ = this.store.select(RootState.content);
	}

	ngOnInit(): void {
		this.createForm();

		this.content$
			.pipe(
				filter((content) => !!content),
				take(1)
			)
			.subscribe((content) => {
				this.termsAndConditions$ = this.contentService.getTermsConditions(content.stateCode, this.culture).pipe(take(1));
			});

		this.store.select(GuardianState.guardians).subscribe((guardians) => {
			if (guardians && guardians.length > 0) {
				this.guardians = guardians;
				this.termsConditionsForm.controls['termsGuardian'].setValue(this.guardians[0].internalGuardianId);
			}
		});
	}

	ngAfterViewInit(): void {

		($('.nha-sa-terms-link') as any).modaal({
			content_source: '#termsAndConditions',
			width: 800
		});
	}

	createForm(): void {
		this.termsConditionsForm = this.fb.group({
			termsGuardian: ['', Validators.required],
			termsAgree: [false, Validators.requiredTrue]
		});
	}
}
